import API from '@module/API';
import ArchiveFiltersController from './ArchiveFiltersController';
import PaginationFilter from './controls/PaginationFilter';
import ProgramActivityFilter from './controls/ProgramActivityFilter';
import ProgramCatFilter from './controls/ProgramCatFilter';
import ProgramDirectionFilter from './controls/ProgramDirectionFilter';
import SearchFilter from './controls/SearchFilter';
import TagsFilter from './controls/TagsFilter';

const initArchiveFilters = (client: API): ArchiveFiltersController => {
    const controller = new ArchiveFiltersController(client);

    controller
        .registerMany([
            new TagsFilter(),
            new ProgramCatFilter(),
            new ProgramDirectionFilter(),
            new ProgramActivityFilter(),
            new SearchFilter(),
            new PaginationFilter(),
        ])
        .boot();

    return controller;
};

export default initArchiveFilters;